<template>
  <div
    class="cell"
    :class="{
      disabled: factor.d || paused,
      point: factor.pt !== undefined,
      selected: isSelected,
      'inc-blink': factor.b !== null && factor.b,
      'dec-blink': factor.b !== null && !factor.b
    }"
    @click="click">
    <span v-if="factor.d">--</span>
    <span v-else-if="factor.v">{{ factor.v }}</span>
    <span v-else>{{ factor.pt }}</span>
  </div>
</template>

<script>
export default {
  props: {
    factor: Object,
    event: Number,
    paused: Boolean
  },
  computed: {
    isSelected () {
      if (!this.factor.h) return false
      return this.$store.getters['betSlip/isFactorSelected'](this.event, this.factor.h) && this.$store.state.isUserLoggedIn
    }
  },
  methods: {
    click () {
      if (this.paused || this.factor.v === undefined) return
      if (this.isSelected) {
        this.$store.dispatch('betSlip/REMOVE_POSITION', this.event)
      } else {
        this.$store.dispatch('betSlip/PUT_POSITION', {
          event: this.event,
          factor: this.factor.h,
          value: this.factor.v
        })
      }
    }
  }
}
</script>

<style scoped>
.cell { align-items: center; background: rgba(255, 255, 255, .05); border-bottom: 10px; cursor: pointer; display: flex; flex: 1 1; margin-left: 1px; overflow: hidden; position: relative; text-align: center; -webkit-transition: all .3s; -moz-transition: all .3s; -o-transition: all .3s; transition: all .3s; }
.cell:hover { background: rgba(255, 255, 255, .1) }
.cell.selected { outline: 1px solid #8c9eff; }
.cell span { width: 100%; }
.disabled.cell,
.point.cell { background: rgba(255, 255, 255, .05); color: #999; cursor: default; }
</style>



// WEBPACK FOOTER //
// src/components/sports/matches/FactorCell.vue